import React from 'react';
import PropTypes from 'prop-types';

import { countryOptions } from '../packs/helpers/form_support';

class ValidatingForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      erroredFields: null,
      errorMessage: '',
      serverErrors: [],
    };

    this.state.erroredFields = this.initialErrors();

    this.addError = this.addError.bind(this);
    this.removeError = this.removeError.bind(this);
    this.updateErrorMessage = this.updateErrorMessage.bind(this);
  }

  setAmericanID() {
    if (!countryOptions || !countryOptions()) {
      // Could not find country options. This will prevent users from selecting the dropdown.
      return
    }
    try {
      this.americanID = countryOptions().find((element) => {
        return element.label === 'United States'
      }).value;
    } catch (_err) {
      // Prevents the page from crashing, allowing the user to still select some options.
      this.americanID = null;
    }
  }

  updateErrorMessage() {
    let errorMessage;
    if (this.errors().length) {
      errorMessage = this.errors().join(', ');
    } else {
      errorMessage =  this.state.serverErrors.join(', ');
    }

    this.setState({
      errorMessage: errorMessage,
    });
  }

  isValid() {
    return Object.keys(this.state.erroredFields).length === 0;
  }

  errors() {
    return Object.values(this.state.erroredFields).filter((error) => {
      return error !== '' && error !== undefined;
    })
  }

  addError(fieldName, errorMessage) {
    this.setState({
      erroredFields: Object.assign({}, this.state.erroredFields, { [fieldName]: errorMessage })
    });
  }

  removeError(fieldName) {
    const erroredFields = Object.assign({}, this.state.erroredFields);
    delete erroredFields[fieldName];

    this.setState({
      erroredFields: erroredFields
    });
  }

  requiredFieldNames() {
    return [];
  }

  handleSubmitErrors(error) {
    var errorMessages;

    if (error.response.status == 500 || error.response.status == 400) {
      errorMessages = [error.response.statusText]
    } else {
      const errors = error.response.data.errors;
      errorMessages = Object.keys(errors).map((key) => {
        let message = `${key.replace(/.*(?=\.)+\./, "").replace("_", " ")} ${errors[key]}`;
        return message.charAt(0).toUpperCase() + message.slice(1);
      });
    }

    this.setState({ serverErrors: errorMessages }, () => {
      this.updateErrorMessage();
    });
  }

  initialErrors() {
    const erroredFields = {};
    this.requiredFieldNames().forEach((fieldName) => {
      const ministerValue = this.props.minister[fieldName];
      if (ministerValue === undefined || ministerValue === '') {
        erroredFields[fieldName] = '';
      }
    });
    
    return erroredFields;
  }

  isAmerican(countryID) {
    if (!this.americanID) {
      this.setAmericanID();
    }

    return countryID === this.americanID;
  }
}

ValidatingForm.propTypes = {
  minister: PropTypes.object.isRequired,
};

export default ValidatingForm;
